// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"
import { Trans } from "@lingui/react"
import styled from "styled-components/macro"
import { getDurationStr } from "../dateTime"

const TotalTimeLabel = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 18px;
  margin-top: -4px;
`

const TotalTimeDuration = styled.span`
  color: ${({ theme }): string => theme.colors.nero};
`

type Props = {
  duration: number,
  className?: string,
}

const TotalTime = ({
  duration,
  className,
}: Props): React.ReactElement<Props> => (
  <TotalTimeLabel className={className}>
    <Trans id="label_total_time" message="Total Time"/>{": "}
    <TotalTimeDuration>{getDurationStr(duration)}</TotalTimeDuration>
  </TotalTimeLabel>
)

export default TotalTime
